/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type Props = {
  onClick: () => void;
  hasIcon?: boolean;
};

export const SidebarItemWrapper = styled.button<Props>`
  padding: ${theme.spacing.spacing04} ${theme.spacing.spacing02};
  column-gap: ${theme.spacing.spacing03};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  width: 100%;
  background: none;
  border: none;
  border-bottom: 1px solid ${theme.color.border.border01};

  :nth-child(odd) {
    background-color: ${theme.color.background.ui02};
  }

  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui04};
  }
`;
